<template>
  <div
    :class="['ticket-chip-container', $listeners.click && 'ticket-chip-container-link']"
    :style="{
      gap: linked === TicketLinkingEnum.NO_LINKING ? '1.5rem' : '0.75rem',
      borderColor: selected ? '#666' : '#f5f5f5',
    }"
    @click="e => $emit('click', e)"
  >
    <div class="label-container">
      <slot name="left-slot" />
      <span class="label" :style="`${linked}`">{{ label }}</span>
      <span v-if="number || number === 0" class="number">{{ number }}</span>
    </div>
    <slot name="right-slot" />
  </div>
</template>

<script>
import { TicketLinkingEnum } from '@/types'

export default {
  name: 'ticket-chip',
  props: {
    label: {
      type: String,
      default: '',
    },
    linked: {
      type: String,
      default: 'NO_LINKING',
    },
    number: Number,
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    TicketLinkingEnum() {
      return TicketLinkingEnum
    },
  },
}
</script>

<style scoped>
.ticket-chip-container {
  display: flex;
  height: 2rem;
  padding: 0 0.5rem;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;

  border-radius: 1.5rem;
  border: 1px solid #f5f5f5;
  background-color: white;
}

.ticket-chip-container-link:hover {
  cursor: pointer;
}

.label-container {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.label {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;

  overflow: hidden;
  color: #666;
  leading-trim: both;
  text-edge: cap;
  text-overflow: ellipsis;
  font-family: 'Source Sans Pro';
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
}

.number {
  padding: 0 0.25rem;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.125rem;
  background: #f0f6fa;

  color: #0277bd;
  leading-trim: both;
  text-edge: cap;
  font-family: 'Source Sans Pro';
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
</style>
